import { render, staticRenderFns } from "./ApiUnlimitedInstitutions.vue?vue&type=template&id=33c2a309&scoped=true"
import script from "./ApiUnlimitedInstitutions.vue?vue&type=script&lang=js"
export * from "./ApiUnlimitedInstitutions.vue?vue&type=script&lang=js"
import style0 from "./ApiUnlimitedInstitutions.vue?vue&type=style&index=0&id=33c2a309&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c2a309",
  null
  
)

export default component.exports